/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * GetOrganizationTrialResponse is the response message for GetOrganizationTrial.
 * @export
 * @interface GetOrganizationTrialResponse
 */
export interface GetOrganizationTrialResponse {
    /**
     * grace_period_end_time is the time when the grace period ends.
     * @type {string}
     * @memberof GetOrganizationTrialResponse
     */
    'gracePeriodEndTime'?: string;
    /**
     * in_grace_period indicates whether the trial has expired but the organization is still in the grace period.
     * @type {boolean}
     * @memberof GetOrganizationTrialResponse
     */
    'inGracePeriod'?: boolean;
    /**
     * sales_contacted indicates whether sales has been contacted; doing so automatically prolongs the trial.
     * @type {boolean}
     * @memberof GetOrganizationTrialResponse
     */
    'salesContacted'?: boolean;
    /**
     * status is the current status of the trial.
     * @type {string}
     * @memberof GetOrganizationTrialResponse
     */
    'status'?: GetOrganizationTrialResponseStatusEnum;
    /**
     * trial_end_time is the time when the trial period ends.
     * @type {string}
     * @memberof GetOrganizationTrialResponse
     */
    'trialEndTime'?: string;
    /**
     * trial_start_time is the time when the trial period started.
     * @type {string}
     * @memberof GetOrganizationTrialResponse
     */
    'trialStartTime'?: string;
}

export const GetOrganizationTrialResponseStatusEnum = {
    UNSPECIFIED: 'TRIAL_STATUS_UNSPECIFIED',
    PENDING: 'TRIAL_STATUS_PENDING',
    ACTIVE: 'TRIAL_STATUS_ACTIVE',
    CONVERTED: 'TRIAL_STATUS_CONVERTED',
    EXPIRED: 'TRIAL_STATUS_EXPIRED'
} as const;

export type GetOrganizationTrialResponseStatusEnum = typeof GetOrganizationTrialResponseStatusEnum[keyof typeof GetOrganizationTrialResponseStatusEnum];


